import React from 'react'
import { Item } from '../components/screens/screenAppointmentsList/CustomSteps'
import { localDate } from '../lib/utilsCommon'
import { formatAppointmentStartTime } from '../components/screens/ScreenAppointmentInfo'
import { formatClientName } from '../components/screens/ScreenClientCard'
import { IAppointmentGetAppointment } from '../interfaces/rpc/IAppointmentGetAppointment'

interface UseAppointmentsStepsItemsResult {
  items: Item[]
  current: number
}

export const useAppointmentsStepsItems = (appointments: IAppointmentGetAppointment[] = []): UseAppointmentsStepsItemsResult => {
  const appointmentsKey = React.useMemo(
    () =>
      appointments
        .map(a => `${a.appointment.id}:${a.appointment.start}:${a.appointment.status}`)
        .join('|'),
    [appointments]
  )

  return React.useMemo(() => {
    const now = new Date()
    const timeline = [
      ...appointments.map(ap => localDate(ap.appointment.start)),
      new Date(now.getTime() + 1000)
    ]
    const current = timeline.findIndex(dt => dt > now)
    const items = appointments.map(ap => ({
      id: ap.appointment.id,
      title: [
        formatAppointmentStartTime(ap.appointment),
        formatClientName(ap.client)
      ] as [string, string],
      cancelled: ['CANCELLED_BY_BUSINESS', 'CANCELLED_BY_CLIENT'].includes(ap.appointment.status),
      description: [
        [
          ap.taxonomy?.alias,
          ap.receptionType?.name
        ].filter(Boolean).join(', '),
        [
          ap.appointment.context?.businessName,
          ap.appointment.context?.resourceName
        ].filter(Boolean).join(' / ')
      ].filter(Boolean).join(' • '),
      context: ap.appointment.context
    }))
    return { items, current }
  }, [appointmentsKey])
}
